import React, { useState, useEffect, useRef, Fragment } from "react";
import PropTypes from "prop-types";
import { css } from "emotion";
import { useNewOffer } from "../../../js/context/new-offer";
import R from "ramda";
import Input from "../../AtomicInput";
import SelectForm from "../../AtomicSelect";
import { Icon } from "@maxmilhas/hangar-components-atomic/public";
import { offerMilesStyle, averageMilesStyle } from "./style";
import { milesMask } from "../utils/masks";
import { intFormat, formatOnlyNumbers, formatCurrency, floatFormat } from "../utils/formats";
import Loading from "../Loading/Loading";
import Callout from "../Callout/Callout";
import InputForm from "../../atoms/InputForm";
import {
	MANAGER_LIMIT_AVERAGE_MILES,
	MINIMAL_MILES_ADVANCED_AVERAGE,
	MINIMAL_MILES_SMILES_REDUCTIONS,
	AIRLINE_PROGRAMS,
} from "../../../js/shared/enums";
import SwitchForm from "../../atoms/SwitchForm";
import { MediaVendasModal } from "../../../js/services/modals";
import RegistrationData from "../../../js/components/new-offer/step2-registrationData";
import Accordion from "../../atoms/Accordion";
import { AverageMessage } from "../../../js/components/shared/miles-average/AverageMessage";
import mask from "../../../js/shared/moneyMask";
import PubSub from "pubsub-js";
import DynamicRange from "../../../js/components/molecules/DynamicRange";
import BlackFridayRange from "../../../js/components/organisms/BlackFridayRange";
import PaymentGuarantee from "../../PaymentGuarantee/PaymentGuarantee";
import AcceptanceTerms from "../AcceptanceTerms/AcceptanceTerms";
import { Tooltip } from "react-tippy";
import theme from "../../../../js/shared/new-theme";
import {
	MULTIPLE_MILES_OFFER as multipleMilesOffer
} from "../../../../js/shared/constants";
import { formatPaymentDeadline } from "../utils/formats";

// Debounce function
let timerId;
const debounced = (fn, delay = 250) => {
	if (timerId) clearTimeout(timerId);
	timerId = setTimeout(fn, delay);
};

const BoxOfferMiles = ({ checkData, setInputInFocus, inputInFocus, typePhoneLatam }) => {
	const {
		currentProgram,
		fetchRankingData,
		participantData,
		offerData,
		rankingData,
		pricesData,
		setOfferData,
		setRankingData,
		fetchPricesData,
		smilesDiamond,
		setSmilesDiamond,
		allPhonesMultiplus,
		loyaltyData: {
			data: { phone }
		},
		editOffer,
		newOfferTempData,
		statisticSales,
		fetchStatisticSales,
		bonusData: { data: bonusData },
		acceptanceTerms,
		setAcceptanceTerms,
		twoFactorData
	} = useNewOffer();

	const { minMiles, maxMiles, minPrice, maxPrice, valSuggestMin, valSuggestMax } = pricesData.data;

	const [openFidelityAndBank, setOpenFidelityAndBank] = useState(undefined);
	const [openDynamicRange, setOpenDynamicRange] = useState(undefined);
	const [valid, setValid] = useState(false);
	const [priceOfferMiles, setPriceOfferMiles] = useState(
		!!offerData.data.price && offerData.data.price !== "undefined" ? `R$ ${formatCurrency(offerData.data.price)}` : ""
	);
	const [quantOfferMiles, setQuantOfferMiles] = useState(
		offerData.data.quant || editOffer.quant || ""
	);
	const [paymentDeadline, setPaymentDeadline] = useState(
		offerData.data.paymentDeadline || editOffer.paymentDeadline || ""
	);
	const [paymentScheduleType, setPaymentScheduleType] = useState(
		offerData.data.paymentScheduleType || editOffer.paymentScheduleType || ""
	);
	const quantRef = useRef(quantOfferMiles);
	const [maxAverage, setMaxAverage] = useState(
		participantData.hasManagementActive ? MANAGER_LIMIT_AVERAGE_MILES : offerData.data.averageMilesMax || 0
	);

	const [errors, setErrors] = useState({
		priceOfferMiles:
			priceOfferMiles &&
			(floatFormat(priceOfferMiles) < minPrice || floatFormat(priceOfferMiles) > maxPrice),
		quantOfferMiles: quantOfferMiles && ((quantOfferMiles < minMiles || quantOfferMiles > maxMiles) || quantOfferMiles % multipleMilesOffer !== 0)
	});
	const [averageOfferMiles, setAverageOfferMiles] = useState(offerData.data.averageMiles || "");
	const [averageMilesPerTicket, setAverageMilesPerTicket] = useState(
		offerData.data.averageMiles || ""
	);
	const [advancedSettings, setAdvancedSettings] = useState(false);
	const [optionsMilesReductionTickets, setOptionsMilesReductionTickets] = useState([]);
	const [optionsAverageMilesPerTicket, setOptionsAverageMilesPerTicket] = useState([]);

	const [modals, setModals] = useState({
		mediaVendas: false,
		firstOpen: false,
		numberAverageTicket: 0,
		value: 0,
		sale: {}
	});

	const { reductions } = offerData.data;

	const showReductions =
		currentProgram.id === AIRLINE_PROGRAMS.SMILES.id &&
		!participantData.hasManagementActive &&
		smilesDiamond === true &&
		!!optionsMilesReductionTickets.length;

	useEffect(() => {
		handleReductions(
			pricesData.data.reductionRanges,
			quantOfferMiles,
			reductions,
			averageMilesPerTicket,
			offerData.data.averageMilesMax
		);
	}, []);

	useEffect(() => {
		if (
			openFidelityAndBank === undefined &&
			newOfferTempData.form.completedBoxDataBankDetails !== undefined &&
			newOfferTempData.form.completedBoxDataFidelityProgramDetails !== undefined
		) {
			let invalidPhone = currentProgram.id === 3 && !allPhonesMultiplus.find(p => p.phone == phone);
			setOpenFidelityAndBank(
				invalidPhone ||
					!newOfferTempData.form.completedBoxDataBankDetails ||
					(!newOfferTempData.form.completedBoxDataFidelityProgramDetails &&
						!participantData.hasManagementActive)
			);
		}
	}, [
		newOfferTempData.form.completedBoxDataBankDetails,
		newOfferTempData.form.completedBoxDataFidelityProgramDetails
	]);

	useEffect(() => {
		setAverageOfferMiles(offerData.data.averageMiles);
	}, [offerData.data.averageMiles]);

	useEffect(() => {
		const averageMilesMax = parseInt(offerData.data.averageMilesMax);
		if (averageMilesMax > 0)
			setMaxAverage(averageMilesMax);
	}, [offerData.data.averageMilesMax]);

	const getReductions = async (isSmilesDiamond) => {
		await fetchRankingData(quantOfferMiles, currentProgram, undefined, false, async data => {
			await handleReductions(data.reductionRanges, quantOfferMiles, undefined, undefined, isSmilesDiamond, maxAverage);
		});
	};

	const toggleCheckSmiles = async value => {
		setSmilesDiamond(value);

		if (value) {
		 	if(optionsMilesReductionTickets.length > 0) {
				changeReduction(
					optionsMilesReductionTickets[optionsMilesReductionTickets.length - 1].quantReduction
				);
			} else {
				await getReductions(value);
			}
		} else {
			changeReduction(0);
		}
	};

	const handleReductions = async (
		reductionRanges = [],
		quantMiles,
		defaultReduction,
		averageMilesPerTicket,
		isSmilesDiamond = false,
		averageMax
	) => {
		if (reductionRanges.length) {
			let newReductions = [
				{
					label: "0 passageiro",
					value: 0
				}
			];

			let reductionsSorted = R.sortBy(R.prop("quantReduction"), reductionRanges);
			reductionsSorted.forEach(r => {
				newReductions.push({
					...r,
					label: `${r.quantReduction} passageiro${r.quantReduction > 1 ? "s" : ""}`,
					value: r.quantReduction
				});
			});
			setOptionsMilesReductionTickets(newReductions);
			// Checkbox marcado OU usuario salvo com categoria diamante
			if (
				(isSmilesDiamond || smilesDiamond) &&
				quantMiles >= MINIMAL_MILES_SMILES_REDUCTIONS &&
				(defaultReduction === undefined || defaultReduction > 0) // Caso for redução 0 não precisa setar
			) {
				return await changeReduction(
					defaultReduction || reductionsSorted[reductionsSorted.length - 1].quantReduction,
					newReductions,
					quantMiles,
					averageMilesPerTicket,
					averageMax
				);
			}
		} else {
			setOptionsMilesReductionTickets([]);
			setOptionsAverageMilesPerTicket([]);
		}

		return {};
	};

	const changeReduction = async (
		value,
		reductionRanges = optionsMilesReductionTickets,
		quant = quantOfferMiles,
		averageMilesPerTicket,
		averageMax
	) => {
		let newReduction = reductionRanges.find(r => r.quantReduction === value);
		let newOfferData = {
			...offerData.data,
			quant
		};
		if (newReduction) {
			let newAverages = [];
			newReduction.averageRanges.forEach(a => {
				if (averageMax && averageMax > 0 && a > averageMax) return;

				newAverages.push({
					label: intFormat(a),
					value: a
				});
			});
			setOptionsAverageMilesPerTicket(newAverages);

			let newAverageMiles = averageMilesPerTicket
				? newReduction.averageRanges.find(av => av === averageMilesPerTicket)
				: undefined;
			newAverageMiles = newAverageMiles || newReduction.averageRanges[0];
			setAverageMilesPerTicket(newAverageMiles);

			newOfferData = {
				...newOfferData,
				reductions: value,
				averageMiles: newReduction.averageRanges[0]
			};
			await setOfferData({
				data: newOfferData
			});
			await fetchPricesData(quant, currentProgram, newReduction.averageRanges[0]);
		} else {
			let newAverageMiles = rankingData.data.averageMilesSuggestion || averageOfferMiles;
			setAverageOfferMiles(newAverageMiles);
			newOfferData = {
				...newOfferData,
				reductions: value,
				averageMiles: newAverageMiles
			};
			await setOfferData({
				data: newOfferData
			});
			await fetchPricesData(quant, currentProgram, newAverageMiles);
		}

		return newOfferData;
	};

	const onChange = async (name, value) => {
		switch (name) {
			case "milesReductionTickets":
				value = parseInt(value);
				changeReduction(value, optionsMilesReductionTickets, quantOfferMiles, undefined, maxAverage);
				break;
			case "priceOfferMiles":
				let price = value.length ? floatFormat(value) : undefined;

				let priceOfferMilesIsValid = price >= minPrice && price <= maxPrice;

				setPriceOfferMiles(value);
				setErrors({
					...errors,
					priceOfferMiles: !priceOfferMilesIsValid
				});

				await setOfferData({
					data: {
						...offerData.data,
						price: formatCurrency(price),
						invalid: !priceOfferMilesIsValid
					}
				});

				break;
			case "quantOfferMiles":
				let numberQuant = value.length ? parseInt(formatOnlyNumbers(value)) : undefined;

				let quantOfferMilesIsValid = numberQuant >= minMiles && numberQuant <= maxMiles && numberQuant % multipleMilesOffer === 0;

				quantRef.current = numberQuant;

				setQuantOfferMiles(value.length ? numberQuant : "");
				setMaxAverage(
					participantData.hasManagementActive
						? MANAGER_LIMIT_AVERAGE_MILES
						: value.length
						? numberQuant
						: 0
				);
				setAverageOfferMiles("");
				let newErrors = {
					...errors,
					quantOfferMiles: !quantOfferMilesIsValid
				};
				setErrors(newErrors);

				if (quantOfferMilesIsValid) {
					let newOfferData = { ...offerData.data, quant: numberQuant };
					await setOfferData({
						data: newOfferData
					});
					await fetchRankingData(numberQuant, currentProgram, undefined, false, async data => {
						if (quantRef.current != numberQuant) {
							return;
						}

						const averageMilesMax = parseInt(data.averageMilesMax) || numberQuant;
						if (!participantData.hasManagementActive && averageMilesMax)
							setMaxAverage(numberQuant < averageMilesMax ? numberQuant : averageMilesMax);

						newOfferData = {
							...newOfferData,
							...(await handleReductions(data.reductionRanges, numberQuant, undefined, undefined, undefined, averageMilesMax))
						};

						let averageMiles = data.averageMilesSuggestion;
						if (!averageMiles || !data.countAllowedSales) {
							setAdvancedSettings(true);
						}

						if (!smilesDiamond) {
							setAverageOfferMiles(averageMiles);
							await setOfferData({
								data: { ...newOfferData, averageMiles }
							});
							if (averageMiles >= minMiles) {
								setErrors({
									...newErrors,
									averageOfferMiles:
										averageMiles < minMiles ||
										averageMiles > numberQuant ||
										(participantData.hasManagementActive &&
											averageMiles > MANAGER_LIMIT_AVERAGE_MILES)
								});
							}
						} else if (numberQuant < 60000 && !!data.countAllowedSales) {
							// Caso usuário for diamante e esta ofertando menos que 60k
							newOfferData.reductions = numberQuant >= 35000 ? 1 : 0;
							setAverageOfferMiles(3500);
							await setOfferData({
								data: { ...newOfferData }
							});
						}
					}, paymentDeadline, paymentScheduleType);
				} else {
					setRankingData({ ...rankingData, data: {} });
					setPriceOfferMiles("");
					await setOfferData({
						data: { ...offerData.data, price: "" }
					});
				}
				break;
			case "averageMilesPerTicket":
				let numberAverageTicket = value.length ? parseInt(formatOnlyNumbers(value)) : undefined;
				if (numberAverageTicket > 25000 && !modals.firstOpen) {
					let sale = statisticSales.data.find(
						val => val.initialMiles <= numberAverageTicket && val.finalMiles >= numberAverageTicket
					);
					setModals({
						mediaVendas: true,
						firstOpen: true,
						numberAverageTicket,
						value,
						sale
					});

					return;
				}
				setAverageMilesPerTicket(value.length ? numberAverageTicket : "");
				await setOfferData({
					data: { ...offerData.data, averageMiles: numberAverageTicket }
				});
				await fetchRankingData(quantOfferMiles, currentProgram, numberAverageTicket, false, null, paymentDeadline, paymentScheduleType);
				break;
			case "averageOfferMiles":
				let numberAverage = value.length ? parseInt(formatOnlyNumbers(value)) : undefined;

				let averageOfferMilesIsValid = numberAverage >= minMiles && numberAverage <= maxAverage;

				setAverageOfferMiles(value.length ? numberAverage : "");
				setErrors({
					...errors,
					averageOfferMiles: !averageOfferMilesIsValid
				});

				if (averageOfferMilesIsValid) {
					// await fetch new prices
					await setOfferData({
						data: { ...offerData.data, averageMiles: numberAverage }
					});
					await fetchRankingData(quantOfferMiles, currentProgram, numberAverage, false, null, paymentDeadline, paymentScheduleType);
					if (numberAverage > 25000) {
						await fetchStatisticSales();
					}
				}
				break;
			case "showAdvancedSettings":
				setAdvancedSettings(!advancedSettings);
				break;
		}
	};

	const getAdvancedConfigMinMiles = () =>
		bonusData && bonusData.enabled ? bonusData.minMiles : MINIMAL_MILES_ADVANCED_AVERAGE;

	const ruleOver60 =
		quantOfferMiles >= getAdvancedConfigMinMiles(currentProgram) &&
		(currentProgram.international === "0" || !currentProgram.international || currentProgram.id === AIRLINE_PROGRAMS.TAP.id);

	let newValid =
		quantOfferMiles && priceOfferMiles && !errors.quantOfferMiles && !errors.priceOfferMiles;
	let average = reductions > 0 ? averageMilesPerTicket : averageOfferMiles;
	if (ruleOver60) {
		newValid =
			newValid &&
			average &&
			average >= minMiles &&
			average <= maxAverage &&
			!errors.averageOfferMiles;
	}

	if (valid !== newValid) {
		setValid(newValid);
		checkData("completedBoxOfferMiles", newValid);
	}

	const eventDetail = isOpen => {
		PubSub.publish("dataLayer", {
			event: "gaEvent",
			gaEventCategory: "Minhas ofertas",
			gaEventAction: "Cadastro de oferta",
			gaEventLabel: "Dados bancários e do programa",
			gaEventDetail: !isOpen ? "Abrir" : "Fechar"
		});
	};

	const changeAverageSlider = async value => {
		if (reductions) {
			onChange("averageMilesPerTicket", String(value));
		} else {
			onChange("averageOfferMiles", value);
		}
	};

	const inputCheckDiamond = currentProgram.id === AIRLINE_PROGRAMS.SMILES.id && !participantData.hasManagementActive && (
		<>
			<hr className="check-smiles-diamond--separator" />
			<div className="check-smiles-diamond--wrapper">
				<Input
					name="checkSmilesDiamond"
					id="checkSmilesDiamond"
					type="checkbox"
					label={
						<span className="check-smiles-diamond--label">
							Eu sou cliente da <strong>Categoria Diamante</strong>
						</span>
					}
					value={!!smilesDiamond}
					checked={!!smilesDiamond}
					onChange={() => toggleCheckSmiles(!smilesDiamond)}
				/>
			</div>
		</>
	);

	const selectPassengers = showReductions && optionsMilesReductionTickets.length > 0 ? (
		<div className="miles-reduction-tickets">
			<SelectForm
				value={reductions}
				name="milesReductionTickets"
				options={optionsMilesReductionTickets.map(r => {
					return { label: r.label, value: r.value };
				})}
				onFocus={() => setInputInFocus("milesReductionTickets")}
				onChange={ev => {
					let val = ev.target.value;
					debounced(() => onChange("milesReductionTickets", val), 300);
				}}
				defaultOption=""
				label="Passagens com redução de milhas"
				data-action="simulator-miles-reducao-select"
			/>
		</div>
	) : null;

	const blockQuantMiles = (
		<div className="quant-offer-miles">
			<div className="payment-deadline--wrapper">
				<InputForm
					className="payment-deadline--component"
					name="paymentDeadline"
					id="paymentDeadline"
					value={formatPaymentDeadline(paymentDeadline, paymentScheduleType)}
					disabled
					placeholder=""
					label={
						<Fragment>Prazo de pagamento 
							<Tooltip
								tabIndex={0}
								arrow={true}
								position="top"
								theme="light"
								html={
									<p
										style={{
											color: theme.palette.gray[500].value
										}}
									>
										O prazo para o pagamento começa a contar a partir das emissões das passagens.
									</p>
								}
							>
								<Icon
									name="icon-max-communication-doubt"
									size="small"
									color={theme.palette.secondary[500].value}
								/>
							</Tooltip>
						</Fragment>
					}
				/>
			</div>
			<div className="quant-offer-miles--wrapper">
				<InputForm
					className="quant-offer-miles--component"
					name="quantOfferMiles"
					id="quantOfferMiles"
					type="tel"
					value={intFormat(quantOfferMiles)}
					onChange={ev => onChange("quantOfferMiles", ev.target.value)}
					onFocus={() => setInputInFocus("quantOfferMiles")}
					placeholder=""
					label="Milhas ofertadas"
					mask={milesMask}
					hasError={errors.quantOfferMiles}
					errorMessage={
						quantOfferMiles < minMiles
							? `A oferta precisa ter no mínimo ${intFormat(minMiles)} milhas`
							: quantOfferMiles > maxMiles
							? `A oferta precisa ter no máximo ${intFormat(maxMiles)} milhas`
							: `Vendas só de ${multipleMilesOffer} em ${multipleMilesOffer} milhas`
					}
					data-action="simulator-miles-quant-miles"
				/>
			</div>
			
			{ruleOver60 && (
				<SwitchForm
					name="showAdvancedSettings"
					id="showAdvancedSettings"
					label="Exibir configurações avançadas"
					onChange={checked => onChange("showAdvancedSettings", checked)}
					checked={advancedSettings}
					dataAction="simulator-miles-advanced-settings"
				/>
			)}
		</div>
	);

	const inputOrSelectAverageMiles =
		!showReductions || !reductions ? (
			<div className="average-offer-miles--wrapper">
				<InputForm
					className="average-offer-miles--component"
					name="averageOfferMiles"
					id="averageOfferMiles"
					type="tel"
					value={intFormat(averageOfferMiles)}
					onChange={ev => {
						let val = ev.target.value;
						debounced(() => onChange("averageOfferMiles", val), 300);
					}}
					onFocus={() => setInputInFocus("averageOfferMiles")}
					placeholder=""
					label="Média de milhas por passageiro"
					mask={milesMask}
					disabled={rankingData.isFetching}
					hasError={errors.averageOfferMiles}
					errorMessage={
						!averageOfferMiles || averageOfferMiles < 3500
							? `A média precisa ter no mínimo ${intFormat(minMiles)} milhas`
							: `A média precisa ter no máximo ${intFormat(maxAverage)} milhas`
					}
					data-action="simulator-miles-average-miles"
				/>
			</div>
		) : (
			<div className="average-miles-per-ticket">
				<SelectForm
					name="averageMilesPerTicket"
					value={averageMilesPerTicket}
					options={optionsAverageMilesPerTicket}
					onFocus={() => setInputInFocus("averageMilesPerTicket")}
					onChange={ev => {
						let val = ev.target.value;
						debounced(() => onChange("averageMilesPerTicket", val), 300);
					}}
					defaultOption="A partir de:"
					label="Média de milhas por passageiro"
					data-action="simulator-miles-average-miles"
				/>
			</div>
		);

	const blockAverageMiles = advancedSettings && ruleOver60 && (
		<>
			{inputCheckDiamond}
			{selectPassengers}
			{inputOrSelectAverageMiles}
			<div
				className={css`
					${averageMilesStyle}
				`}
			>
				<div className="info">
					{rankingData.isFetching ? (
						<div className="info-loading">
							<Loading width={36} height={36} />
						</div>
					) : (
						!!rankingData.data.averageMilesSuggestion &&
						(!showReductions || !reductions) && (
							<AverageMessage
								averageMilesSuggestion={rankingData.data.averageMilesSuggestion}
								averageMiles={averageOfferMiles}
								data={statisticSales.data}
								minMiles={minMiles}
								maxAverage={maxAverage}
							/>
						)
					)}
				</div>
				<hr className="average-separator" />
			</div>
		</>
	);

	const blockPrice = (
		<div className="price-offer-miles">
			<div className="price-offer-miles--wrapper">
				<InputForm
					className="price-offer-miles--component"
					name="priceOfferMiles"
					id="priceOfferMiles"
					type="tel"
					disabled={!quantOfferMiles || errors.quantOfferMiles}
					value={priceOfferMiles}
					onKeyUp={ev => {
						![8, 46, 37, 39].includes(ev.keyCode) &&
							ev.target.setSelectionRange(ev.target.value.length, ev.target.value.length);
					}}
					onChange={ev => {
						let val = ev.target.value;
						const { maskedValue } = mask(val, 2, ",", ".", false, "R$ ");
						setPriceOfferMiles(maskedValue);
						debounced(() => onChange("priceOfferMiles", maskedValue), 300);
					}}
					maxLength="8"
					onFocus={() => setInputInFocus("priceOfferMiles")}
					placeholder=""
					label="Valor a cada 1.000 milhas"
					guide={false}
					hasError={errors.priceOfferMiles && !errors.quantOfferMiles}
					errorMessage={`O valor precisa estar entre ${formatCurrency(minPrice)} e ${formatCurrency(
						maxPrice
					)}`}
					data-action="simulator-miles-price"
				/>
			</div>
			{rankingData.isFetching || pricesData.isFetching ? (
				<div className="price-offer-miles--loading">
					<Loading width={36} height={36} />
				</div>
			) : !!quantOfferMiles && !errors.quantOfferMiles ? (
				<p className="price-offer-miles--text">
					Sugerido entre&nbsp;
					<span>R$ {formatCurrency(valSuggestMin)}</span> e&nbsp;
					<span>R$ {formatCurrency(valSuggestMax)}</span>
				</p>
			) : (
				<></>
			)}
		</div>
	);

	const blockDynamicRange = false && (
		<Accordion
			title="Quer cadastrar um valor maior?"
			onClick={() => {
				setOpenDynamicRange(prevState => !prevState);
			}}
			isOpen={openDynamicRange}
			dataAction={openDynamicRange ? "dynamic-range-close" : "dynamic-range-open"}
		>
			<DynamicRange
				bestAverage={rankingData.data.averageMilesSuggestion}
				averageMiles={averageOfferMiles}
				startAverage={minMiles}
				endAverage={maxAverage}
				changeAverageSlider={changeAverageSlider}
				validRange={reductions && reductions.value && optionsAverageMilesPerTicket} // reducao && reducao.value && mediasOptions
			/>
		</Accordion>
	);

	const blockDynamicBonus = bonusData.enabled && quantOfferMiles >= bonusData.minMiles && (
		<BlackFridayRange
			averageMiles={averageOfferMiles}
			startAverage={bonusData.minAverage}
			price={bonusData.value}
			countAllowedSales={rankingData.data.countAllowedSales}
			quantMiles={quantOfferMiles}
			endAverage={bonusData.maxAverage}
			changeAverageSlider={changeAverageSlider}
			minCPFs={bonusData.minCPFs}
			validRange={!!reductions && optionsAverageMilesPerTicket}
		/>
	);
	const blockFidelityAndBank = !!editOffer.id && (
		<Accordion
			title={
				participantData.hasManagementActive
					? "Dados do programa de fidelidade"
					: "Dados bancários e do programa"
			}
			onClick={() => {
				eventDetail(openFidelityAndBank);
				setOpenFidelityAndBank(prevState => !prevState);
			}}
			isOpen={openFidelityAndBank}
			dataAction={openFidelityAndBank ? "fidelity-and-bank-close" : "fidelity-and-bank-open"}
		>
			<RegistrationData
				fidelityProgram={currentProgram}
				inputInFocus={inputInFocus}
				setInputInFocus={setInputInFocus}
				embeded
				typePhoneLatam={typePhoneLatam}
			/>
		</Accordion>
	);

	const blockAcceptanceTerms = !!editOffer.id && (
		<AcceptanceTerms acceptanceTerms={acceptanceTerms} setAcceptanceTerms={setAcceptanceTerms} />
	);

	const blockAlertLatam = twoFactorData.is2FAEnabled && (
		<div className="alert-offer-miles">
			<Callout show warn text={<span>{twoFactorData.alert}</span>} />
		</div>
	);

	const confirmVendasModal = async () => {
		setModals({
			...modals,
			mediaVendas: false
		});
		setAverageMilesPerTicket(modals.value.length ? modals.numberAverageTicket : "");
		await setOfferData({
			data: { ...offerData.data, averageMiles: modals.numberAverageTicket }
		});
		await fetchPricesData(quantOfferMiles, currentProgram, modals.numberAverageTicket);
	};

	return (
		<div
			className={css`
				${offerMilesStyle}
			`}
		>
			<p className="title">Oferta de milhas</p>
			{blockAlertLatam}
			{blockQuantMiles}
			{blockAverageMiles}
			{blockPrice}
			{blockDynamicRange}
			{blockDynamicBonus}
			{blockFidelityAndBank}
			{blockAcceptanceTerms}

			<MediaVendasModal
				show={modals.mediaVendas}
				media={rankingData.data.averageMilesSuggestion}
				percent={modals.sale.percentage}
				onConfirm={confirmVendasModal}
				onCancel={() => {
					setModals({
						...modals,
						mediaVendas: false
					});
				}}
			/>
		</div>
	);
};

BoxOfferMiles.propTypes = {
	checkData: PropTypes.func,
	setInputInFocus: PropTypes.func
};

export default BoxOfferMiles;
